/*jQuery(window).on("load", function() {
    jQuery(".loader").delay(350).fadeOut(300);
});*/

jQuery(window).on("load", function() {
    jQuery('.recruitment .recruitment__tab--item:first-child').addClass('is-active');
    jQuery('.recruitment .panel:first-child').addClass('is-show');
});
jQuery(window).on("load", function() {
    jQuery('.achiveYomi li:not(:first-child)').addClass('tile3');
});
// IEのガタつき防止
jQuery(window).on("load resize orientationchange", function() {
    if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
        jQuery('body').on("mousewheel", function() {
            event.preventDefault();
            var wd = event.wheelDelta;
            var csp = window.pageYOffset;
            window.scrollTo(0, csp - wd);
        });
    }
});

/*画面高さ取得・代入*/
jQuery(window).on("load resize orientationchange", function() {
    hsize = jQuery(window).height();
    jQuery(".loader").css("height", hsize + "px");
});
// ==============================================================
// ハンバーガーメニュー　20190911
// ==============================================================
jQuery(function() {
    function toggleNav() {
        var body = document.body;
        var hamburger = document.getElementById('js-hamburger');
        var blackBg = document.getElementById('js-black-bg');
        hamburger.addEventListener('click', function() {
            body.classList.toggle('nav-open');
        });
        blackBg.addEventListener('click', function() {
            body.classList.remove('nav-open');
        });
    }
    toggleNav();
});
//追記
jQuery(function() {
    jQuery(".global-nav__item a").on("click", function() {
        if (jQuery("body").hasClass('nav-open')) {
            jQuery("body").removeClass('nav-open');
        }
    });
});

// ===================================================================
// ヘッダー スクロール変化
// ===================================================================
jQuery(function() {
    var $win = jQuery(window),
        $header = jQuery('#grandnav'),
        animationClass = 'is-animation';
    $win.on('load scroll', function() {
        var value = jQuery(this).scrollTop();
        if (value > 180) {
            $header.addClass(animationClass);
        } else {
            $header.removeClass(animationClass);
        }
    });
});

// ===================================================================
// スマホのアドレスバーを除いた画面サイズを取得
// ===================================================================
// スマートフォンで全画面表示
jQuery(document).ready(function() {
    var hSize = jQuery(window).height();
    jQuery('.global-nav').height(hSize); // アドレスバーを除いたサイズを付与
    // jQuery('.black-bg').height(hSize - 60); // アドレスバーを除いたサイズを付与
});
jQuery(window).resize(function() { // ページをリサイズした時の処理
    var hSize = jQuery(window).height();
    jQuery('.global-nav').height(hSize); // アドレスバーを除いたサイズを付与
    // jQuery('.black-bg').height(hSize - 60); // アドレスバーを除いたサイズを付与
});

// ===================================================================
// gotoボタン
// ===================================================================
jQuery(function() {
    var topBtn = jQuery('#page-top');
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    //スクロールしてトップ
    topBtn.click(function() {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});


//--------------------------------
//  heademenuボタン
//--------------------------------
jQuery(function() {
    jQuery('.globalnav-toggle__btn, .open').on('click', function() {
        // クリックでコンテンツを開閉
        jQuery(this).next().slideToggle(200);
        /*矢印の向きを変更*/
        jQuery(this).toggleClass('open', 200);
    });

});

//--------------------------------
//  footermenuボタン
//--------------------------------
jQuery(function() {
    jQuery('.contents_footer__sitemap--menu').on('click', function() {
        /*クリックでコンテンツを開閉*/
        jQuery(this).next().slideToggle(200).css('display', 'flex');
        /*矢印の向きを変更*/
        jQuery(this).toggleClass('open', 200);
    });
});
//--------------------------------
//  全フォーム プライバシーポリシーボタン
//--------------------------------
jQuery(function() {
    jQuery('.js-privacy-open').on('click', function() {
        jQuery(this).next().slideToggle(200);
        jQuery(this).toggleClass('is-active', 200);
    });
});
//--------------------------------
//  recruit__entry form toggleボタン
//--------------------------------
jQuery(function() {
    jQuery('.recruit__entry__privacy').on('click', function() {
        /*クリックでコンテンツを開閉*/
        jQuery(this).next().slideToggle(200);
        /*矢印の向きを変更*/
        jQuery(this).toggleClass('open', 200);
    });
});
//--------------------------------
//  faq-list toggleボタン
//--------------------------------
jQuery(function() {
    jQuery('.faq-list__contents__head').on('click', function() {
        /*クリックでコンテンツを開閉*/
        jQuery(this).next().slideToggle(200);
        /*矢印の向きを変更*/
        jQuery(this).toggleClass('open', 200);
    });
});



jQuery(function() {
    jQuery('.control-group__button').on('click', function() {
        jQuery(this).toggleClass('is-active');
    });
    jQuery('.sale_sort__reseet--btn').on('click', function() {
        jQuery('.control-group__button').removeClass('is-active');
    });
});



///スムーススクロール
jQuery(window).on("load", function() {
    //URLのハッシュ値を取得
    var urlHash = location.hash;
    //ハッシュ値があればページ内スクロール
    var headerHight = 100; //ヘッダの高さ

    //通常のクリック時
    jQuery('a[href^="#"]').not('.noscroll').click(function() {
        //ページ内リンク先を取得
        var href = jQuery(this).attr("href");

        //リンク先が#か空だったらhtmlに
        var hash = href == "#" || href == "" ? 'html' : href;
        //スクロール実行
        scrollToAnker(hash);
        //リンク無効化
        return false;
    });

    // 関数：スムーススクロール
    // 指定したアンカー(#ID)へアニメーションでスクロール
    function scrollToAnker(hash) {
        var target = jQuery(hash);
        var position = target.offset().top - headerHight;
        jQuery('body,html').stop().animate({ scrollTop: position }, 500);
    }
})


// 販売物件フォーム見学か物件を知りたいかのチェック
// jQuery(function() {
//     jQuery('.kengaku').click(function() {
//         jQuery('#kengakuCheck').prop('checked', true);
//     });
//     jQuery('.bukken').click(function() {
//         jQuery('#bukkenCheck').prop('checked', true);
//     });
//     jQuery('.renovation').click(function() {
//         jQuery('#renovationCheck').prop('checked', true);
//     });
// });


// 汎用アコーディオン
jQuery('.js-toggle').on("click", function() {
    jQuery(this).next().slideToggle(200);
    jQuery(this).toggleClass("is-open");
});

